export default "__VITE_ASSET__BmwDc8qc__"